export const faqData = [
  {
    id: 1,
    question: "Can I use a wedding loan for post-wedding expenses like travel?",
    answer:
      "Yes, wedding loans can be used for honeymoon expenses or any post-wedding requirements.",
  },
  {
    id: 2,
    question: "What documents are required for a wedding loan?",
    answer:
      "Typically, you'll need ID proof, address proof, income proof, and a photograph.",
  },
  {
    id: 3,
    question: "What are the repayment options for wedding loans?",
    answer:
      "You can repay through EMIs, which are calculated based on the tenure and interest rate chosen.",
  },
  {
    id: 4,
    question: "How do I avoid loan rejection?",
    answer:
      "Ensure you meet the lender's eligibility criteria and maintain a good credit score.",
  },
];
